import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../utils/apiBaseQuery";
import { DocumentInterface } from "../interfaces/documents/DocumentInterface";
import { mapDocumentsResponse } from "./adapters/mapDocumentsResponse";

export const documentsApiSlice = createApi({
    reducerPath: "documentsApi",
    baseQuery: apiBaseQuery(),
    tagTypes: ["Documents"],
    endpoints: (builder) => ({
        getDocuments: builder.query<DocumentInterface[], void>({
            query: () => "apiV2/dealer/documents",
            transformResponse: mapDocumentsResponse,
            providesTags: ["Documents"],
        }),
    }),
});

export const { useGetDocumentsQuery, useLazyGetDocumentsQuery } =
    documentsApiSlice;
